import React from 'react';
import { Box, Chip, Tooltip } from '@mui/material';
import { LaserMachine } from '../types';
import { MACHINE_LICENSES, getLicenseInfo } from '../utils/licenses';

/** Le tre licenze aggiuntive come chip compatti (dettaglio nel tooltip). */
const MachineLicenseChips: React.FC<{ machine: Partial<LaserMachine> }> = ({ machine }) => (
  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
    {MACHINE_LICENSES.map(({ key, label, shortLabel }) => {
      const info = getLicenseInfo(machine, key);
      return (
        <Tooltip key={key} title={`${label}: ${info.text}`}>
          <Chip
            label={`${shortLabel}: ${info.status === 'ACTIVE' ? 'attivo' : info.status === 'EXPIRED' ? 'scaduto' : 'non incluso'}`}
            size="small"
            color={info.color}
            variant={info.status === 'ACTIVE' ? 'filled' : 'outlined'}
            sx={info.status === 'DISABLED' ? { opacity: 0.6 } : undefined}
          />
        </Tooltip>
      );
    })}
  </Box>
);

export default MachineLicenseChips;
